import { getInstance } from "./authWrapper"

export const authGuard = (to, from, next) => {
    const authService = getInstance()

    const fn = () => {
        if (authService.isAuthenticated) {
            if (to.name.match('account') && authService.user['https://branfts.com/roles'].includes('collector')) {
                return next({ name: 'gallery' })
            }
            return next()
        }

        authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } })
    }

    if (!authService.loading) {
        return fn()
    }

    authService.$watch("loading", loading => {
        if (loading === false) {
            return fn()
        }
    })
}
